import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { ProfilePageBannerMutationKeys } from '../../../keys'
import {
	UpdateProfilePageBannerRequest,
	UpdateProfilePageBannerResponse,
} from '../../../type'
import { updateProfilePageBanner } from '../../services'

interface UseMutationUpdateProfilePageBannerProps {
	id: string
	payload: UpdateProfilePageBannerRequest
}

export default function useMutationUpdateProfilePageBanner(
	props?: UseBaseMutationOptions<
		UpdateProfilePageBannerResponse,
		UseMutationUpdateProfilePageBannerProps
	>,
) {
	return useMutation({
		mutationKey: [ProfilePageBannerMutationKeys.UpdateProfilePageBanner],
		mutationFn: (params) => updateProfilePageBanner(params.id, params.payload),
		...props,
	})
}
